export const TYPOGRAPHY = {
  TITLE: 'Зарабатывайте с Циан',
  SUBTITLE: 'Проводите сделки с квартирами от застройщиков и получайте вознаграждение!',
};
